"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.isEnabledDate = exports.isDisabledWeekday = exports.isDateBetween = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _moment = _interopRequireDefault(require("moment"));

var isDateBetween = function isDateBetween(date, blockedDates, isRangeEnabled) {
  if (typeof blockedDates === 'undefined' || typeof blockedDates[0] === 'undefined' || typeof blockedDates[1] === 'undefined') {
    return false;
  }

  if (typeof isRangeEnabled !== 'undefined' || isRangeEnabled) {
    if (blockedDates[0].isAfter(blockedDates[1])) {
      return blockedDates[1].isBefore(date) && blockedDates[0].isAfter(date);
    }
  }

  return blockedDates[0].isBefore(date, 'day') && blockedDates[1].isAfter(date, 'day');
};

exports.isDateBetween = isDateBetween;

var isDisabledWeekday = function isDisabledWeekday(date, weekDays) {
  if (!weekDays) {
    return false;
  }

  var daysName = _moment.default.weekdays();

  return (0, _indexOf.default)(weekDays).call(weekDays, daysName[date.day()]) > -1;
};

exports.isDisabledWeekday = isDisabledWeekday;

var isEnabledDate = function isEnabledDate(day, dateProps) {
  var disableWeekends = dateProps.disableWeekends,
      disableAfterDate = dateProps.disableAfterDate,
      disableBeforeDate = dateProps.disableBeforeDate,
      blockedDates = dateProps.blockedDates,
      disableWeekday = dateProps.disableWeekday,
      disablePastDates = dateProps.disablePastDates,
      disableFutureDates = dateProps.disableFutureDates,
      disabledDates = dateProps.disabledDates;
  return !isDisabledWeekday(day, disableWeekday) && !(disableWeekends && (day.day() === 0 || day.day() === 6)) && !(disableBeforeDate && day.isBefore((0, _moment.default)(disableBeforeDate), 'day')) && !(disableAfterDate && day.isAfter((0, _moment.default)(disableAfterDate), 'day')) && !(disablePastDates && day.isBefore((0, _moment.default)(), 'day')) && !(disableFutureDates && day.isAfter((0, _moment.default)(), 'day')) && !isDateBetween(day, blockedDates && (0, _map.default)(blockedDates).call(blockedDates, function (date) {
    return (0, _moment.default)(date);
  })) && !isDateBetween(day, disabledDates && (0, _map.default)(disabledDates).call(disabledDates, function (date) {
    return (0, _moment.default)(date);
  }));
};

exports.isEnabledDate = isEnabledDate;